import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api, { setPageMeta } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Splatter } from "@/components/Splatter";
import { Loader2 } from "lucide-react";

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const category = params.get("category") || "";
  const [cats, setCats] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setPageMeta("Boutique — Tenay Ain-Pression", "Découvrez nos créations 3D : lithophanies, figurines, objets personnalisés et pièces techniques.");
    api.get("/categories").then(({ data }) => setCats(data)).catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    const p = {};
    if (category && category !== "demande-de-devis") p.category = category;
    api.get("/products", { params: p }).then(({ data }) => setProducts(data)).finally(() => setLoading(false));
  }, [category]);

  const selectCat = (slug) => {
    if (slug) setParams({ category: slug }); else setParams({});
  };

  return (
    <div className="relative">
      <section className="relative overflow-hidden border-b border-white/10">
        <Splatter />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-14">
          <h1 className="font-heading text-4xl sm:text-5xl font-black">La boutique</h1>
          <p className="mt-3 text-gray-400 max-w-2xl">Commandez nos créations ou personnalisez-les. Livraison partout en France.</p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
        <div className="flex flex-wrap gap-3 mb-10">
          <button data-testid="filter-all" onClick={() => selectCat("")}
            className={`rounded-full px-4 py-2 text-sm font-bold border transition-colors ${!category ? "bg-[#E6007E] border-[#E6007E] text-white" : "border-white/20 text-gray-300 hover:border-[#E6007E]"}`}>
            Tout
          </button>
          {cats.filter((c) => c.slug !== "demande-de-devis" && c.slug !== "impression-fichier-3d").map((c) => (
            <button key={c.slug} data-testid={`filter-${c.slug}`} onClick={() => selectCat(c.slug)}
              className={`rounded-full px-4 py-2 text-sm font-bold border transition-colors ${category === c.slug ? "bg-[#E6007E] border-[#E6007E] text-white" : "border-white/20 text-gray-300 hover:border-[#E6007E]"}`}>
              {c.name}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="py-24 flex justify-center"><Loader2 className="w-8 h-8 animate-spin text-[#E6007E]" /></div>
        ) : products.length === 0 ? (
          <p className="py-24 text-center text-gray-400">Aucun produit dans cette catégorie pour le moment.</p>
        ) : (
          <div className="grid gap-6 grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
          </div>
        )}
      </div>
    </div>
  );
}
